import React from 'react';
import ChatImage from './ChatImage';
import './Chat.css';

function getDisplayName(user, message) {
  const name = (user?.name ?? message?.name ?? '').toString().trim();
  return name || 'User';
}

function getInitial(name) {
  const n = (name || 'U').trim();
  return n.charAt(0).toUpperCase();
}

export default function ChatMessage({ message, replyToMessage, user, currentUserId, isMentioned }) {
  const isOwn = currentUserId != null && String(message.userId) === String(currentUserId);
  const time = new Date(message.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  const displayName = getDisplayName(user, message);
  const initial = getInitial(displayName);

  return (
    <div className={`chat-message ${isOwn ? 'chat-message--outgoing' : 'chat-message--incoming'} ${user?.role === 'staff' ? 'chat-message--staff' : 'chat-message--student'} ${isMentioned ? 'chat-message--mentioned' : ''}`}>
      {!isOwn && (
        <>
          {user?.avatar ? (
            <img src={user.avatar} alt={displayName} className="chat-message-avatar rounded-full shrink-0" />
          ) : (
            <span className="chat-message-avatar chat-message-avatar-initial rounded-full shrink-0" aria-hidden="true">{initial}</span>
          )}
          <div className="chat-message-body">
            <span className="chat-message-name">{displayName}{user?.role === 'staff' ? ' (Staff)' : ''}</span>
            {replyToMessage && (
              <div className="chat-reply-tag">
                Reply to {(replyToMessage.user?.name ?? replyToMessage.name ?? 'User')}: {replyToMessage.text.slice(0, 35)}{replyToMessage.text.length > 35 ? '…' : ''}
              </div>
            )}
            <div className="chat-message-bubble chat-message-bubble--incoming">
              {message.text && <span className="chat-message-text">{message.text}</span>}
              {message.imageUrl && <ChatImage src={message.imageUrl} alt="Attachment" />}
            </div>
            <span className="chat-message-time">{time}</span>
          </div>
        </>
      )}
      {isOwn && (
        <>
          <div className="chat-message-body chat-message-body--outgoing">
            {replyToMessage && (
              <div className="chat-reply-tag">
                Reply to {(replyToMessage.user?.name ?? replyToMessage.name ?? 'User')}: {replyToMessage.text.slice(0, 35)}{replyToMessage.text.length > 35 ? '…' : ''}
              </div>
            )}
            <div className="chat-message-bubble chat-message-bubble--outgoing">
              {message.text && <span className="chat-message-text">{message.text}</span>}
              {message.imageUrl && <ChatImage src={message.imageUrl} alt="Attachment" />}
            </div>
            <span className="chat-message-time">{time}</span>
          </div>
        </>
      )}
    </div>
  );
}
